module.exports = __webpack_public_path__ + "img/news8.9ec8581e.svg";